import { AxiosResponse } from 'axios';
import axiosConfig from '../../../../../config/axiosConfig';

const CM0013Api = () => {
    return {};
};

export default CM0013Api;
